import React from 'react';

export default function() {
  return (
      // Note to future implementer: feel free to delete this h1
      <h1>Feature List</h1>
  );
}
